var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('button',{staticClass:"hover:bg-gray-200 hover:text-pink-600 px-6 py-5 mr-auto",on:{"click":function($event){return _vm.toggleNav()}}},[(_vm.$store.state.settings.ui.nav.hidden)?_c('span',{staticClass:"fa fa-bars"}):_c('span',{staticClass:"fa fa-chevron-left"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }